<template>
  <footer class="footer">
    <nav>
      <ul>
        <li>
          <router-link to="/about">Wer ist URS?</router-link>
        </li>
        <li>
          <router-link to="/about">Impressum</router-link>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    // title: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer{
  background: var(--color-beige);
  padding: 15px 15px;
  line-height: 1;
  margin-top: 50px;
  font-size: .8rem;

  ul{
    list-style-type: none;
    padding:0;
    display: flex;
    justify-content: center;

    li{
      &:not(:last-child){
        margin-right: 20px;
      }
    }
  }
}
</style>
